import React, { Component } from 'react';

//import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

//import Moment from 'moment';
import ModuleLoadingSpinner from '../../components/UI/ModuleLoadingSpinner';

import Hoc from '../../hoc/hoc';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';

import classes from './QuizIntro.css';

class QuizIntro extends Component {

	state = {
		first: false,
		second: false,
		latestGameTimer: null,
		timerCountdown: null,
		timerString: null,
	};

	countDownInterval = null;

	handleChange = name => event => {
		this.setState({ [name]: event.target.checked });
	};

	componentWillReceiveProps = (nextProps) => {
		//console.log('quiz intro nextprops: ',nextProps);
		if (nextProps.isAuthenticated && (nextProps.canPlay===null) && nextProps.canPlayLoading===false) {
			//console.log('checking latest game');
			this.props.onCheckLatestGame(nextProps.userID);
		} else if (nextProps.canPlayTimestamp!==null && nextProps.canPlay===false) {
			this.setState({
				...this.state,
				latestGameTimer: parseInt(nextProps.canPlayTimestamp,10),
				timerCountdown: parseInt(nextProps.canPlayTimestamp,10)
			});
			this.startCountDown();
		}
		
		if (nextProps.isAuthenticated===false) {
			clearInterval(this.countDownInterval);
			this.countDownInterval=null;
			this.props.onResetLatestGameTimestamp(null,null);
		}
	}

	componentWillUnmount = () => {
		clearInterval(this.countDownInterval);
		this.countDownInterval=null;
		this.props.onResetLatestGameTimestamp(null,null);
	}

	startCountDown = () => {
		//console.log ('start countdown:',this.countDownInterval);
		if (this.countDownInterval) return;
		//console.log("quiz counter starting countdown", this.countDownInterval);
		this.countDownInterval = setInterval(()=>{
			let oldcnt = parseInt(this.state.timerCountdown,10);
			//const strCnt = Moment(parseInt(oldcnt,10)).format("hh:mm:ss");

			var tempTime = Math.round(oldcnt/1000);
			var helperDate = new Date(null);
				helperDate.setSeconds(tempTime); // specify value for SECONDS here
				var strCnt = helperDate.toISOString().substr(11, 8);
			//var strCnt = tempTime.hours() + " : " + tempTime.minutes() + " : " + tempTime.seconds();

			//console.log(strCnt);
			const newCount = oldcnt - 1000;
			if (oldcnt > 0) {
				this.setState({
					...this.state,
					timerCountdown:newCount,
					timerString: strCnt
				});
			} else {
				clearInterval(this.countDownInterval);

				// start QUIZ
				// trebalo bi poceti countup tek kada se odbije resp od baze
				//axios.
				//this.props.onQuizStart(this.props.quizSession,this.props.userID,'start');
				//this.startTimeCount();
				//this.props.onChangeQuizState('started');
			}
		},1000);
	}

	doClick2 = () => {
		this.props.history.push('/pravila');
		this.props.onUpdateLPElement("zero");
		this.props.onUpdateLPPosition(0);
		this.props.onUpdatePath('/pravila');
	}


	render () {

		const { first, second } = this.state;
		const error = Object.values(this.state).filter(v => v).length !== 2;

		let compBody = '';
		let authOverlay = null;
		let playTimer = '';

		if (!this.props.isAuthenticated) {
			authOverlay = (
				<div className={classes.authOverlay}>
					<h2
						className={classes.largeHeadlineBlack}
					>
						Da biste polagali Durex ispit, neophodno je da se prijavite na svoj nalog.<br/>Ukoliko niste registrovan korisnik, potrebno je da najpre izvršite registraciju.
					</h2>
					<Button variant="contained" size="large" color="secondary" className={classes.button}
						onClick={ () => {
							this.props.onUpdateModal(true,'login');
						}
						}
					>
					Prijava
					</Button>
				</div>
			)
		}

		if (this.props.canPlayLoading) {
			compBody = <ModuleLoadingSpinner/>;
		} else {
			if (this.props.canPlay === true) {
				compBody = (
					<Hoc>
						<h2 className={classes.h2Custom}>Prijavi se za Durex ispit,<br/>odgovori brzo i tačno na 10 pitanja iz oblasti seksa<br/>i možeš osvojiti vredne nagrade!</h2>
					
						<div className={classes.startForm}>
							<FormControl required error={error} component="fieldset" className={classes.formControl}>
								<FormGroup>
									<FormControlLabel
									control={
														<Checkbox 
															color="primary" 
															checked={first} 
															onChange={this.handleChange('first')} 
															value="first" 
															className={classes.checkBox}
													/>
													}
													label={
														<FormLabel component="legend">Potvrđujem da imam više od 18 godina, da sam pročitao/la &nbsp;
														<a 
															onClick= { () => {
																this.doClick2();
															}}
														> Pravila i uslove učestvovanja</a>,
														kao i da sam saglasan/na sa istim.</FormLabel>
													}
													className={classes.formControlLabel}
									/>
									<FormControlLabel
									control={
										<Checkbox color="primary" checked={second} onChange={this.handleChange('second')} value="second" />
									}
													label={
														<FormLabel component="legend">Potvrđujem da Reckitt Benckiser i SmartPoint Adria mogu koristiti moje podatke isključivo u cilju pristupa, identifikacije i učestvovanja u takmičenju "Love University", kao i da me mogu kontaktirati radi slanja nagrada, do 15. decembra.</FormLabel>
													}
													className={classes.formControlLabel}
									/>
								</FormGroup>
							</FormControl>
							<Button variant="contained" size="large" color="primary" className={classes.button}
								disabled={error}
								onClick={ () => 
									{
										this.props.history.push('/kviz');
										this.props.onUpdatePath('/kviz');
										this.props.onUpdateLPElement('zero');
										this.props.onUpdateLPPosition(0);
									}
								}
							>
								Započnite ispit
							</Button>
						</div>
					</Hoc>
				)
			} else {
				playTimer = this.state.timerString;
				compBody = (
					<Hoc>
						<h2 className={classes.h2Custom}>Danas ste već iskoristili šansu za igranje.</h2>
						<p>Možete pokušati ponovo za <br/><span className={classes.h2Custom}>{playTimer}</span></p>
						{/*
						<hr/>
						<p>Dev opcija:</p>
						<Button variant="contained" size="large" color="primary" className={classes.button}
							onClick={ () => 
								{
									this.props.history.push('/kviz');
									this.props.onUpdatePath('/kviz');
									this.props.onUpdateLPElement('zero');
									this.props.onUpdateLPPosition(0);
								}
							}
						>
							Započnite ispit
						</Button>
						*/}
					</Hoc>
				)
			}
		}

		return (
		<div className={classes.quizIntroContainer}>
			<div style={{width:'100%',textAlign:'center'}} >
				<h1 className={classes.h1Custom}>Durex ispit</h1>
			</div>
			{compBody}
			{authOverlay}
		</div>
		);
	}
};

const mapStateToProps = state => {
	return {
		curPath: state.my.currentPath,
		isAuthenticated: state.auth.token !== null,
		userID: state.auth.userId,
		canPlay: state.auth.canPlay,
		canPlayLoading: state.auth.canPlayLoading,
		canPlayTimestamp: state.auth.canPlayTimestamp,
	};
}

const mapDispatchToProps = dispatch => {
	return {
		onUpdateModal: (modState, modWhat) => dispatch( actions.changeModal(modState, modWhat) ),
		onUpdateLPElement: (lpel) => dispatch ( actions.changeLandingPageElement(lpel) ),
		onUpdateLPPosition: (lpPos) => dispatch ( actions.changeLandingPagePosition(lpPos) ),
		onUpdatePath: (newpath) => dispatch (actions.changePath(newpath)),
		onCheckLatestGame: (uid) => dispatch (actions.checkLatestGame(uid)),
		onResetLatestGameTimestamp: (canplay,timestamp) => dispatch(actions.canIPlay(canplay,timestamp)),
	}
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizIntro));


// WEBPACK FOOTER //
// ./src/components/QuizIntro/QuizIntro.js